<template>
  <section class="hero is-fullheight">
    <div class="container" id="app" style="min-width:100%; margin: 0">
      <b-navbar shadow :mobile-burger="showBurger()">
        <template slot="brand">
    <Logos v-if="user"></Logos>
    <b-navbar-item v-else tag="router-link" :to="{ path: '/' }">
        <img src="/static/images/neoslide_icon.png" alt="">
        <img src="/static/images/name.png" alt="">
  </b-navbar-item>
        </template>

<template slot="start" v-if="user && bIsMobile">
  <MenuMobile></MenuMobile>
  </template>
          <template slot="end">
              <b-navbar-item style="color:#3e8ed0" tag="span" v-if="user">
                Logged in as {{user.email}}
              </b-navbar-item>
              <b-navbar-item v-if="user" tag="div">
                  <div class="buttons">
                      <a @click="logout" class="button selected">
                          Log Out
                      </a>
                  </div>
              </b-navbar-item>
          </template>
      </b-navbar>
      <div class="columns">
        <div class="column is-narrow">
          <SideMenu v-if="user && !bIsMobile"></SideMenu>
        </div>
        <div class="column">
          <router-view @login-clicked="loginClicked"/>
      </div>
    </div>
    <b-navbar centered sticky :mobile-burger="false"><template #brand>
            <b-navbar-item>
                <p style="font-size:13px;color:#a3a3a3">
                  Copyright © 2025 neoslide.mk
                </p>
            </b-navbar-item>
        </template>
        </b-navbar>
  </div>
  </section>
</template>

<script>
import * as firebase from 'firebase'
import Logos from '@/components/Logos.vue'
import SideMenu from '@/components/SideMenu.vue'
import MenuMobile from '@/components/MenuMobile.vue'

export default {
  name: 'App',
  data: () => {
    return {
      user: firebase.auth().currentUser,
      drawer: true,
      right: false,
      mini: false,
      expandOnHover: false,
      background: false,
      bIsMobile: true,
      arrowDown: true,
      // copyrightText: 'Copyright © 2022 neoslide.mk',
      stor: {
        icon: 'storage'
      },
      subItems: [
        { title: 'Playlists', icon: 'horizontal_rule', to: '/playlistsstorage' },
        { title: 'Menus', icon: 'horizontal_rule', to: '/menusstorage' },
        { title: 'Special Offers', icon: 'horizontal_rule', to: '/specialoffersstorage' }
      ]
    }
  },
  components: {
    Logos,
    SideMenu,
    MenuMobile
  },
  created: function () {
    this.bIsMobile = this.isMobile()
    this.init()
  },
  updated: function () {
    if (firebase.auth().currentUser === null) {
      this.user = null
    }
    // this.init()
  },
  methods: {
    init () {
      this.globalLogger('INIT')
      let user = firebase.auth().currentUser
      let database = this.$store.state.database
      let store = this.$store
      if (user) {
        store.state.uid = user.uid
        /* let username = user.email.split('@')[0]
        store.state.username = username */
        // database.ref('/users/' + store.state.uid).on('value', (snapshot) => {
        /* store.state.role = snapshot.val().role
        store.state.workspaceId = snapshot.val().workspaceId
        localStorage.role = snapshot.val().role
        localStorage.workspaceId = snapshot.val().workspaceId */
        // console.log(snapshot.val(), 'snapshot val')
        if (!this.getNotMigrated().includes(user.uid)) {
          this.globalLogger(this.getNotMigrated(), 'doesnt include')
          database.ref('/neoslide/users/' + store.state.uid).on('value', (snapshot) => {
            store.commit('setWorkspaceId', snapshot.val().workspaceId)
            store.commit('setRole', snapshot.val().role)

            let workspaceId = store.state.workspaceId
            this.globalLogger('wks', workspaceId)

            database.ref('/neoslide/app/' + workspaceId).on('value', (snapshot) => { store.commit('setApps', snapshot.val()) })
            database.ref('/neoslide/clusters/' + workspaceId).on('value', (snapshot) => { store.commit('setClusters', snapshot.val()) })
            database.ref('/neoslide/devices/' + workspaceId).on('value', (snapshot) => { store.commit('setDevices', snapshot.val()) })
            database.ref('/neoslide/playlists/' + workspaceId).on('value', (snapshot) => { store.commit('setPlaylists', snapshot.val()) })
            database.ref('/neoslide/archive/' + workspaceId + '/playlists/').on('value', (snapshot) => { store.commit('setPlaylistsArchive', snapshot.val()) })
            database.ref('/neoslide/menu/' + workspaceId).on('value', (snapshot) => { store.commit('setMenus', snapshot.val()) })
            database.ref('/neoslide/archive/' + workspaceId + '/menus/').on('value', (snapshot) => { store.commit('setMenusArchive', snapshot.val()) })
            database.ref('/neoslide/airQualityTypes/').on('value', (snapshot) => { store.commit('setAirQuality', snapshot.val()) })
            database.ref('/neoslide/weatherCities/').on('value', (snapshot) => { store.commit('setWeatherCities', snapshot.val()) })
            database.ref('/neoslide/specialOfferMenu/' + workspaceId).on('value', (snapshot) => { store.commit('setSpecialOffers', snapshot.val()) })
            database.ref('/neoslide/archive/' + workspaceId + '/specialOffers/').on('value', (snapshot) => { store.commit('setSpecialOffersArchive', snapshot.val()) })
            database.ref('/neoslide/campaigns/' + workspaceId).on('value', (snapshot) => { store.commit('setCampaigns', snapshot.val()) })
            database.ref('/neoslide/addOns/' + workspaceId).on('value', (snapshot) => { store.commit('setAddOns', snapshot.val()) })
            database.ref('/neoslide/weatherConf/' + workspaceId + '/apiKey').on('value', (snapshot) => { store.commit('setWeatherApiKey', snapshot.val()) })
            database.ref('/neoslide/powerDevices/' + workspaceId).on('value', (snapshot) => { store.commit('setPowerDevices', snapshot.val()) })
            database.ref('/neoslide/customerSatisfaction/' + workspaceId).on('value', (snapshot) => { store.commit('setCustomerSatisfaction', snapshot.val()) })
            database.ref('/neoslide/frontdesk/' + workspaceId).on('value', (snapshot) => { store.commit('setFrontDesk', snapshot.val()) })
            database.ref('/neoslide/documents/' + workspaceId).on('value', (snapshot) => { store.commit('setDocuments', snapshot.val()) })
            database.ref('/neoslide/questionnaires/' + workspaceId).on('value', (snapshot) => { store.commit('setQuestionnaires', snapshot.val()) })
            database.ref('/neoslide/questionnaireAnswers/' + workspaceId).on('value', (snapshot) => { store.commit('setQuestionnaireAnswers', snapshot.val()) })
            database.ref('/neoslide/appMenu/' + workspaceId).on('value', (snapshot) => { store.commit('setAppMenu', snapshot.val()) })
            database.ref('/neoslide/appMenuPdfs/' + workspaceId).on('value', (snapshot) => { store.commit('setAppMenuPdfs', snapshot.val()) })
            database.ref('/neoslide/tickets/' + workspaceId).on('value', (snapshot) => { store.commit('setTickets', snapshot.val()) })
          })
        } else {
          this.globalLogger('includes in not migrated')
          let username = user.email.split('@')[0]
          store.state.username = username
          // database.ref('/users/' + store.state.uid).on('value', (snapshot) => {
          // store.commit('setRole', snapshot.val().role)
          database.ref('/app/' + store.state.uid).on('value', (snapshot) => { store.commit('setApps', snapshot.val()) })
          database.ref('/clusters/' + store.state.uid).on('value', (snapshot) => { store.commit('setClusters', snapshot.val()) })
          database.ref('/devices/' + store.state.uid).on('value', (snapshot) => { store.commit('setDevices', snapshot.val()) })
          database.ref('/playlists/' + store.state.uid).on('value', (snapshot) => { store.commit('setPlaylists', snapshot.val()) })
          database.ref('/archive/' + store.state.uid + '/playlists/').on('value', (snapshot) => { store.commit('setPlaylistsArchive', snapshot.val()) })
          database.ref('/menu/' + store.state.uid).on('value', (snapshot) => { store.commit('setMenus', snapshot.val()) })
          database.ref('/archive/' + store.state.uid + '/menus/').on('value', (snapshot) => { store.commit('setMenusArchive', snapshot.val()) })
          database.ref('/airQualityTypes/').on('value', (snapshot) => { store.commit('setAirQuality', snapshot.val()) })
          database.ref('/weatherCities/').on('value', (snapshot) => { store.commit('setWeatherCities', snapshot.val()) })
          database.ref('/specialOfferMenu/' + store.state.uid).on('value', (snapshot) => { store.commit('setSpecialOffers', snapshot.val()) })
          database.ref('/archive/' + store.state.uid + '/specialOffers/').on('value', (snapshot) => { store.commit('setSpecialOffersArchive', snapshot.val()) })
          database.ref('/campaigns/' + store.state.uid).on('value', (snapshot) => { store.commit('setCampaigns', snapshot.val()) })
          database.ref('/addOns/' + store.state.uid).on('value', (snapshot) => { store.commit('setAddOns', snapshot.val()) })
          database.ref('/weatherConf/' + store.state.uid + '/apiKey').on('value', (snapshot) => { store.commit('setWeatherApiKey', snapshot.val()) })
          database.ref('/powerDevices/' + store.state.uid).on('value', (snapshot) => { store.commit('setPowerDevices', snapshot.val()) })
          // })
        }
        // })
      }
    },
    loginClicked () {
      this.user = firebase.auth().currentUser
      this.init()
    },
    logout () {
      localStorage.clear()
      firebase.auth().signOut().then(() => {
        this.user = null
        this.$router.replace({ name: 'Login' })
      })
    },
    isMobile () {
      return window.innerWidth <= 800
    },
    showBurger () {
      if (this.user) {
        return true
      } else {
        return false
      }
    }
    /* toggleMenu () {
      if (this.mini) {
        this.copyrightText = 'Copyright © 2022 neoslide.mk'
      } else {
        this.copyrightText = ''
      }
      this.mini = !this.mini
    } */
  }
}
</script>

<style scoped>
.is-fullheight.columns {
    height: calc(100vh - ( 4rem - .75rem ) );
}
.navbar-item img {
  max-height: 3rem;
  margin-right: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue